import {DrupalNode} from "next-drupal";
import {hasCmsIcon, ImageIcon} from "../../atoms/icon";

/**
 * Renders a detail card.
 *
 * @param node
 *   The detail card node.
 * @constructor
 */
export default function NodeDetailCard({ node }: {node: DrupalNode}): JSX.Element {
  return (
    <div className="bg-white p-12 text-center drop-shadow-sm rounded-md">
      {hasCmsIcon(node?.field_detail_card_icon) && (
        <div className="mb-2 h-12">
          <ImageIcon icon={node.field_detail_card_icon} color="primary" height={50} width={50} alt={node.title} className={"m-auto object-contain max-h-full"}/>
        </div>
      )}
      <div className="font-bold text-primary text-2xl pb-3">
        {node.title}
      </div>
      <p>{node.field_detail_card_description}</p>
    </div>
  )
}